// 團體設定的單一真相：group code → 中文名 + 首頁卡片圖。
// 之後要新增團體（例如 ≒JOY 開帳號後），只要在這裡加一筆、
// 並視需要把 code 放進 HOME_GROUPS 讓首頁卡片顯示即可。
import { STATIC_URL as API_BASE_URL } from '../config';

// 卡片圖統一用 /images/avatar/{groupCode}.png
const cardImage = (code) => `${API_BASE_URL}/images/avatar/${code}.png`;

export const GROUPS = {
  nogizaka:         { name: '乃木坂46', image: cardImage('nogizaka') },
  hinatazaka:       { name: '日向坂46', image: cardImage('hinatazaka') },
  sakurazaka:       { name: '櫻坂46',   image: cardImage('sakurazaka') },
  equal_love:       { name: '=LOVE',    image: cardImage('equal_love') },
  not_equal_me:     { name: '≠ME',      image: cardImage('not_equal_me') },
  nearly_equal_joy: { name: '≒JOY',     image: cardImage('nearly_equal_joy') },
};

// 首頁卡片顯示的團體（依序）。
export const HOME_GROUPS = [
  'nogizaka',
  'hinatazaka',
  'sakurazaka',
  'equal_love',
  'not_equal_me',
  'nearly_equal_joy',
];

// groupName 回傳該 code 的中文團名；未知則回空字串。
export const groupName = (code) => GROUPS[code]?.name || '';

// groupSelectOptions 供篩選下拉用：{value, label} 陣列。
// withAll 為 true 時，最前面加一個「全部團體」選項。
export const groupSelectOptions = (withAll = false) => {
  const options = HOME_GROUPS.map((code) => ({ value: code, label: GROUPS[code].name }));
  return withAll ? [{ value: 'all', label: '全部團體' }, ...options] : options;
};

// GROUP_CODES 是所有已知團體 code（不等於首頁顯示清單 HOME_GROUPS）。
// 供短網址路由、權限分頁等「列舉所有團體」的用途；順序依 GROUPS 定義。
export const GROUP_CODES = Object.keys(GROUPS);

// groupOrder 回傳團體的排序權重（依 GROUPS 定義順序）；未知團排到最後。
export const groupOrder = (code) => {
  const idx = GROUP_CODES.indexOf(code);
  return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
};
